<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import {
  getInbound,
  add
  // , getDetails
} from "@/api/storage/inbound";

import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getWarehouse } from "@/api/storage/warehouse";
export default {
  name: "inboundManifest",
  components: {
    cTable
  },
  mounted() {
    // console.log(123);
    // add();
    this.header.searchs.forEach(async item => {
      if (item.key === "clientId")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "warehouseId")
        item.options = (await getWarehouse()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: getInbound
        // getDetails
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            }
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("barCode"),
                key: "bar_code"
              },
              {
                name: () => this.$t("skuName"),
                key: "sku_name"
              },
              {
                name: () => this.$t("doublePrice"),
                key: "declaration_amount"
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "clientId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "warehouseId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("warehouseName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
              // autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("Inbound manifest"),
          key: "manifest_code",
          align: "center"
          // component: "Button",
          // bind: {
          //   type: "primary",
          //   size: "small"
          // },
          // methods: {
          //   click({ row }) {
          //     this.$page.getModal("add").open({ row }, function() {
          //       this.setTitle(row.manifest_code);
          //       this.$page
          //         .handleRequestMethods("getDetails", row.id)
          //         .then(res => {
          //           this.list = res.payload.sku;
          //         });
          //     });
          //   }
          // }
        },
        {
          name: () => this.$t("barCode"),
          key: "bar_code",
          align: "center"
        },
        {
          name: () => this.$t("Inbound pcs"),
          key: "sku_count",
          align: "center"
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center"
        },
        {
          name: () => this.$t("inbound") + this.$t("time"),
          key: "create_time",
          align: "center",
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse_name",
          align: "center"
        },
        {
          name: () => this.$t("Remarks"),
          key: "remark",
          align: "center"
        }
      ]
    };
  }
};
</script>
